import { createElement, useState } from 'react';
import { createRoot } from 'react-dom/client';
import AssetManagerModal from '../../../assets/AssetManagerModal';
import { NotificationsProvider } from '../../../notifications/NotificationProvider';
import NotificationList from '../../../notifications/NotificationList';

interface Props {
    onInsertAsset: (value: string) => void;
    onClose: () => void;
}

const AssetModal = ({ onInsertAsset, onClose }: Props) => {
    const [showAssetModal, setShowAssetModal] = useState(true);
    const onSetShowAssetModal = (show: boolean) => {
        setShowAssetModal(show);
        if (!show) {
            onClose();
        }
    };

    return (
        <NotificationsProvider>
            <NotificationList />
            <AssetManagerModal
                showAssetModal={showAssetModal}
                setShowAssetModal={onSetShowAssetModal}
                onInsertAsset={onInsertAsset}
                allowedExtensions=".jpg,.jpeg,.png,.svg,.gif,.webp,.apng,.avif"
                filterListToAllowedExtensions={true}
            />
        </NotificationsProvider>
    );
};

export const file_picker_callback = (
    callback: (value: string, meta?: Record<string, unknown> | undefined) => void,
) => {
    const element = document.createElement('div');
    const applicationRoot = document.getElementById('root') ?? document.body;
    applicationRoot.append(element);
    const reactRoot = createRoot(element);

    const onClose = () => {
        reactRoot.unmount();
        if (applicationRoot.contains(element)) {
            applicationRoot.removeChild(element);
        }
    };

    const onInsertAsset = (assetURL: string) => {
        callback(assetURL);
        onClose();
    };

    reactRoot.render(
        createElement(AssetModal, {
            onInsertAsset,
            onClose,
        }),
    );
};
